import { jsonToXlsx } from '@/utils/xlsExport/jsonToXlsx';
import i18n from '@/plugins/i18n';
import moment from 'moment';
import { pickOrderObj } from '@/utils/functions';

export const exportXls = (data) => {
  const cols = data.columns;

  cols.push({
    label: i18n.t('Reward Profile') + ` (${i18n.t('Affiliate')})`,
    key: 'affiliate__reward_profile_name'
  });
  cols.push({
    label: i18n.t('Reward Profile') + ` (${i18n.t('Campaign')})`,
    key: 'campaign__reward_profile_name'
  });
  cols.push({
    label: i18n.t('Reward Profile') + ` (${i18n.t('Brand')})`,
    key: 'brand__reward_profile_name'
  });
  cols.push({
    label: i18n.t('Nível 1'),
    key: 'pl1_name'
  });
  cols.push({
    label: i18n.t('Nível 2'),
    key: 'pl2_name'
  });
  cols.push({
    label: i18n.t('Nível 3'),
    key: 'pl3_name'
  });

  let xlsData = data.items.map((item) => {
    item.name = item.action_name;
    item.utm_medium = item.action_utm_medium;
    item.utm_content = item.action_utm_content;

    return pickOrderObj(
      item,
      cols.map((c) => c.key)
    );
  });

  jsonToXlsx({
    name: `${i18n.t('Action Report')} - ${moment().format('DD-MM-YYYY HH:mm')}`,
    headers: cols.map((c) => c.label),
    data: xlsData
  });
};
